import { Chip, Stack, Typography } from '@mui/material';
import DashboardWidgetCard from '../../Dashboard/DashboardWidgetCard';
import StatRow from './StatRow';
import { formatDateTime, formatNumber } from './dashboardFormat';

const STATUS_CHIP = {
  draft: { label: 'Entwurf', color: 'default' },
  active: { label: 'Aktiv', color: 'success' },
  paused: { label: 'Pausiert', color: 'warning' },
};

// Widget 2 — current state of the selected flow (status chip + scheduler facts).
export default function FlowStatusWidget({ flow, loading, error, onRetry }) {
  const chip = STATUS_CHIP[flow?.status] || STATUS_CHIP.draft;

  return (
    <DashboardWidgetCard
      title='Flow Status'
      icon='AccountTree'
      accent='primary'
      loading={loading}
      error={error}
      onRetry={onRetry}
      footer={
        flow?.name ? (
          <Typography variant='caption' color='text.secondary' noWrap title={flow.name}>
            {flow.name}
          </Typography>
        ) : null
      }
    >
      <Stack spacing={1} sx={{ flexGrow: 1 }} justifyContent='center'>
        <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1}>
          <Typography variant='body2' color='text.secondary'>
            Status
          </Typography>
          <Chip
            size='small'
            label={chip.label}
            color={chip.color}
            variant={chip.color === 'default' ? 'outlined' : 'filled'}
          />
        </Stack>
        <StatRow label='Letzter automatischer Check' value={formatDateTime(flow?.lastCheckAt)} />
        <StatRow
          label='Nächster geplanter Versand'
          value={formatDateTime(flow?.nextScheduledSendAt)}
        />
        <StatRow label='Kontakte aktuell im Flow' value={formatNumber(flow?.contactsInFlow)} />
      </Stack>
    </DashboardWidgetCard>
  );
}
